import { OptionsV2 } from "xml2js";

export const XML_OPTIONS: OptionsV2 = {
    explicitArray: false,
    attrkey: "@attrs",
    charkey: "#text",
};
